@if (storeLoaded) {
  <se-po-household-invite
    [profile]="profile"
    [prohibitedEmails]="prohibitedEmails"
    (invite)="handleInvite($event)">
  </se-po-household-invite>
}
